import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import { NavLink } from "react-router-dom";

export const FormTitle = ({ title, subTitle }) => {
  return (
    <Box sx={{ textAlign: "center" }}>
      <Typography
        variant="body1"
        sx={{ fontWeight: "600", fontSize: "24px" }}
        gutterBottom
      >
        {title}
      </Typography>
      <Typography variant="body2" color={"#444444"} fontSize={"15px"}>
        {subTitle}
      </Typography>
    </Box>
  );
};

export const FormFooter = ({ onClick, title, to, label, navTitle }) => {
  return (
    <Grid container justifyContent="center">
      <Grid item>
        <Typography
          variant="body2"
          color="text.secondary"
          textAlign="left"
          style={{ fontSize: '14px' }}
        >
          {label}{' '}
          <NavLink
            to={to}
            style={{
              fontWeight: 600,
              fontSize: '14px',
              color: '#250258', // Replace with your desired color
              textDecoration: 'none',
            }}
            state={{ title }}
            onClick={onClick}
          >
            {navTitle}
          </NavLink>
        </Typography>
      </Grid>
    </Grid>
  );
};
